import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface SynchronizationSliceStateInterface {
    dashboardSynchronize: boolean;
    sessionSynchronize: boolean;
    reportSynchronize: boolean;
    duplicatedFilesSynchronize: boolean;
    purchasePlanSynchronize: boolean;
}

const SynchronizationSliceState: SynchronizationSliceStateInterface = {
    dashboardSynchronize: false,
    sessionSynchronize: false,
    reportSynchronize: false,
    duplicatedFilesSynchronize: false,
    purchasePlanSynchronize: false
};

export const synchronizationSlice = createSlice({
    name: "synchronization",
    initialState: SynchronizationSliceState,
    reducers: {
        setDashboardSynchronize: (state, action: PayloadAction<boolean>) => {
            state.dashboardSynchronize = action.payload;
        },
        setSessionSynchronize: (state, action: PayloadAction<boolean>) => {
            state.sessionSynchronize = action.payload;
        },
        setReportSynchronize: (state, action: PayloadAction<boolean>) => {
            state.reportSynchronize = action.payload;
        },
        setDuplicatedFilesSynchronize: (state, action: PayloadAction<boolean>) => {
            state.duplicatedFilesSynchronize = action.payload;
        },
        setPurchasePlanSynchronize: (state, action: PayloadAction<boolean>) => {
            state.purchasePlanSynchronize = action.payload;
        }
    }
});

export const { setDashboardSynchronize, setReportSynchronize, setSessionSynchronize, setDuplicatedFilesSynchronize, setPurchasePlanSynchronize } =
    synchronizationSlice.actions;
export const selectSynchronization = (state: RootState) => state.synchronization;
export default synchronizationSlice.reducer;
